import(/* webpackMode: "eager", webpackExports: ["HtmlLang"] */ "/codebuild/output/src3457723357/src/rmh-platform/apps/rmh-patient/app/[locale]/HtmlLang.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3457723357/src/rmh-platform/apps/rmh-patient/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3457723357/src/rmh-platform/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3457723357/src/rmh-platform/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3457723357/src/rmh-platform/packages/ui-config/src/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3457723357/src/rmh-platform/packages/ui-config/src/reset.css");
